import React, { useContext, useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

const ForgetPasswordContext = React.createContext();

export function useForgetPassword() {
  return useContext(ForgetPasswordContext);
}

export function ForgetPasswordProvider({ children }) {
  const [forgetPasswordInfo, setForgetPasswordInfo] = useState({
    phoneNumber: "",
    primaryToken: "",
    otpToken: "",
    secondaryToken: "",
  });

  async function firstStep(phone) {
    const dataToSend = {
      phone: phone,
    };

    await fetch("https://api.redfoxcafe.ir/v1/user/forget-password/", {
      method: "POST",
      body: JSON.stringify(dataToSend),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "200") {
          if (data.data.phone !== phone)
            throw new Error("مشکلی پیش آمده. لطفا مجددا تلاش کنید.");

          setForgetPasswordInfo((oldInfo) => ({
            ...oldInfo,
            phoneNumber: data.data.phone,
            primaryToken: data.data.forget_token,
          }));
        } else {
          throw data.message;
        }
      });
  }

  function allowSecondStep() {
    return (
      forgetPasswordInfo.phoneNumber !== "" &&
      forgetPasswordInfo.primaryToken !== ""
    );
  }

  async function secondStep(otp_token) {
    const dataToSend = {
      phone: forgetPasswordInfo.phoneNumber,
      forget_token: forgetPasswordInfo.primaryToken,
      token: otp_token,
    };

    await fetch("https://api.redfoxcafe.ir/v1/user/forget-password-change/", {
      method: "POST",
      body: JSON.stringify(dataToSend),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "200") {
          if (data.data.phone !== forgetPasswordInfo.phoneNumber)
            throw new Error("مشکلی پیش آمده. لطفا مجددا تلاش کنید.");

          setForgetPasswordInfo((oldInfo) => ({
            ...oldInfo,
            secondaryToken: data.data.forget_token,
          }));
        } else {
          throw data.message;
        }
      });
  }

  function allowThirdStep() {
    return (
      forgetPasswordInfo.phoneNumber !== "" &&
      forgetPasswordInfo.primaryToken !== "" &&
      forgetPasswordInfo.secondaryToken !== ""
    );
  }

  async function thirdStep(password) {
    const dataToSend = {
      phone: forgetPasswordInfo.phoneNumber,
      forget_token: forgetPasswordInfo.secondaryToken,
      pass: password,
    };

    await fetch("https://api.redfoxcafe.ir/v1/user/mobile-verification/", {
      method: "POST",
      body: JSON.stringify(dataToSend),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "200") {
          setForgetPasswordInfo({
            phoneNumber: "",
            primaryToken: "",
            otpToken: "",
            secondaryToken: "",
          });

          toast.success("تغییر رمز با موفقیت انجام شد");

          return <Navigate to="\login" replace />;
        } else {
          throw data.message;
        }
      });
  }

  async function resendCode() {
    await firstStep(forgetPasswordInfo.phoneNumber);
  }

  const info = {
    firstStep,
    allowSecondStep,
    secondStep,
    allowThirdStep,
    thirdStep,
    resendCode,
  };

  return (
    <ForgetPasswordContext.Provider value={info}>
      {children}
    </ForgetPasswordContext.Provider>
  );
}
